// extracted by mini-css-extract-plugin
export default {"nav":"Navbar_nav__zY79Q"};